
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { commonRoutes } from "./route"


export const routes: Array<RouteRecordRaw> = [...commonRoutes]


const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({
    top: 0
  }),
  routes
})

export default router
